export default __webpack_public_path__ + "static/mask-mobile-99731009f866279713c8a089f182d40e.png";